import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://bankingfees.eu";

export const SEO = ({ title, description, keywords, noindex = false, canonical, image, jsonLd }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywords} />}
    <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
    {canonical && <link rel="canonical" href={`${SITE_URL}${canonical}`} />}
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta property="og:type" content="website" />
    {canonical && <meta property="og:url" content={`${SITE_URL}${canonical}`} />}
    <meta property="og:image" content={image || `${SITE_URL}/og-image.png`} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    {jsonLd && (
      <script type="application/ld+json">
        {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd])}
      </script>
    )}
  </Helmet>
);
